import { render, staticRenderFns } from "./skipFaceAuth.vue?vue&type=template&id=071a8288&"
import script from "./skipFaceAuth.vue?vue&type=script&lang=js&"
export * from "./skipFaceAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports